import type { TrackerState } from '@racemap/sdk/schema/trackers';
import { isAccessible, isTrackerOnline } from '@racemap/utilities/functions/trackers';
import type { TrackerObject } from '@racemap/utilities/types/trackers';
import type { TableCellProps } from 'react-virtualized';
import { BatteryIndicator } from 'src/components/BatteryIndicator';
import { TrackerColumnKeys } from 'src/store/trackers/trackers_reducers';
import { useCurrentUser } from '../../../../lib/customHooks';
import { Columns } from '../../../DataTable';

interface CellProps extends TableCellProps {
  cellData?: TrackerState['battery'];
  rowData: TrackerObject;
}

export const BatteryColumn = () => {
  const currentUser = useCurrentUser();

  const cellRenderer = ({ rowData }: CellProps) => {
    if (!isAccessible(rowData, currentUser)) return <></>;

    const { battery, charging } = rowData.state;
    const batteryNumber = Math.max(Number(battery) || 0, 0);
    const isConnected = isTrackerOnline(rowData.state);

    return (
      <BatteryIndicator
        batteryPercentage={batteryNumber}
        isCharging={!!charging}
        isActive={!!isConnected}
      />
    );
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.BATTERY,
    label: 'Battery',
    cellRenderer,
    width: 110,
    style: { justifyContent: 'flex-end' },
    headerStyle: { justifyContent: 'center' },
    sortingMethod: (cellDataA: TrackerState['battery'], cellDataB: TrackerState['battery']) => {
      const aBattery = Number(cellDataA) || -10;
      const bBattery = Number(cellDataB) || -10;

      return bBattery - aBattery;
    },
  });
};
